// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3qxqf","buttons":"Footer_buttons___axZS"};